var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1275_1766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3999 0.234375L9.43428 5.2H12.3999V6.4H6.3999C4.85771 6.4 3.5999 7.65781 3.5999 9.2V14.8H0.634277L5.5999 19.7656L10.5655 14.8H7.5999V13.6H13.5999C15.1421 13.6 16.3999 12.3422 16.3999 10.8V5.2H19.3655L14.3999 0.234375ZM14.3999 1.36563L17.4343 4.4H15.5999V10.8C15.5999 11.9094 14.7093 12.8 13.5999 12.8H7.5999V10.4H13.1999V4.4H11.3655L14.3999 1.36563ZM6.3999 7.2H12.3999V9.6H6.7999V15.6H8.63428L5.5999 18.6344L2.56553 15.6H4.3999V9.2C4.3999 8.09063 5.29053 7.2 6.3999 7.2Z",
    fill: "#263238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1275_1766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/Change.f7b2d135f1163a665d5114496365238e.svg";
export { ForwardRef as ReactComponent };